export default {
  path: "/app/vehicle-usage",
  redirect: "/app/vehicle-usage/my-list-can-create-vehicle",
  component: () => import("../layout"),
  children: [
    // MY LIST
    {
      name: "myListTravelRequestCanCreateVehicle",
      path: "/app/vehicle-usage/my-list-can-create-vehicle",
      component: () =>
        import("../../travelRequest/my-travel-request.can-create-vehicle.vue"),
      meta: {
        appName: "myListTravelRequestCanCreateVehicle",
        detail: "detailTravelRequestCanCreateVehicle",
      },
      children: [
        {
          name: "detailTravelRequestCanCreateVehicle",
          path: "/app/vehicle-usage/:id/can-create-vehicle-detail",
          component: () => import("../../travelRequest/detail-view.vue"),
          meta: {
            listName: "myListTravelRequestCanCreateVehicle",
            showRight: true,
            appName: "myListTravelRequestCanCreateVehicle",
            detail: "detailTravelRequestCanCreateVehicle",
          },
        },
      ],
    },
    {
      name: "listTravelRequestForAdmin",
      path: "/app/vehicle-usage/for-admin",
      component: () =>
        import("../../travelRequest/my-travel-request.for-admin.vue"),
      meta: {
        appName: "listTravelRequestForAdmin",
        detail: "detailListTravelRequestForAdmin",
      },
      children: [
        {
          name: "detailListTravelRequestForAdmin",
          path: "/app/vehicle-usage/:id/for-admin-detail",
          component: () => import("../../travelRequest/detail-view.vue"),
          meta: {
            listName: "listTravelRequestForAdmin",
            showRight: true,
            appName: "listTravelRequestForAdmin",
            detail: "detailListTravelRequestForAdmin",
          },
        },
      ],
    },
    {
      name: "myListVehicleUsage",
      path: "/app/vehicle-usage/my-list-vehicle-usage",
      component: () => import("../../travelRequest/my-vehicle.list.vue"),
      meta: {
        appName: "myListVehicleUsage",
        detail: "detailVehicleUsage",
      },
      children: [
        {
          name: "detailVehicleUsage",
          path: "/app/vehicle-usage/:id/detail",
          component: () =>
            import("../../travelRequest/detail-view-vehicle.vue"),
          meta: {
            listName: "myListVehicleUsage",
            showRight: true,
            appName: "myListVehicleUsage",
            detail: "detailVehicleUsage",
          },
        },
      ],
    },
    {
      name: "myListApprovalVehicleUsage",
      path: "/app/vehicle-usage/my-approval-vehicle-usage-list",
      component: () =>
        import("../../travelRequest/my-vehicle.approval-list.vue"),
      meta: {
        appName: "myListApprovalVehicleUsage",
        detail: "detailApprovalVehicleUsage",
      },
      children: [
        {
          name: "detailApprovalVehicleUsage",
          path: "/app/vehicle-usage/:id/approval-detail",
          component: () =>
            import("../../travelRequest/detail-view-vehicle.vue"),
          meta: {
            listName: "myListApprovalVehicleUsage",
            showRight: true,
            appName: "myListApprovalVehicleUsage",
            detail: "detailApprovalVehicleUsage",
          },
        },
      ],
    },
    {
      name: "adminManagerListApprovalVehicleUsage",
      path: "/app/vehicle-usage/admin-manager-approved-list",
      component: () =>
        import("../../travelRequest/vehicle.admin-manager.approval-list.vue"),
      meta: {
        appName: "adminManagerListApprovalVehicleUsage",
        detail: "detailAdminManagerListApprovalVehicleUsage",
      },
      children: [
        {
          name: "detailAdminManagerListApprovalVehicleUsage",
          path:
            "/app/vehicle-usage/admin-manager-approved-list/:id/approval-detail",
          component: () =>
            import("../../travelRequest/detail-view-vehicle.vue"),
          meta: {
            listName: "adminManagerListApprovalVehicleUsage",
            showRight: true,
            appName: "adminManagerListApprovalVehicleUsage",
            detail: "detailAdminManagerListApprovalVehicleUsage",
          },
        },
      ],
    },
    {
      name: "vehicleUsageTypeList",
      path: "/app/vehicle-usage/vehicle-usage-type",
      component: () =>
        import(
          "../../travelRequest/data-lists/vehicleUsageType/vehicle-usage-type.list.vue"
        ),
      meta: {
        appName: "vehicleUsageTypeList",
      },
    },
    //Report
    {
      name: "reportByVehicle",
      path: "/app/vehicle-usage/report-by-vehicle",
      component: () =>
        import(
          "../../travelRequest/childApp/reportVehicle/report-by-vehicle.vue"
        ),
      meta: {
        appName: "reportByVehicle",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "reportByDepartment",
      path: "/app/vehicle-usage/report-by-department",
      component: () =>
        import(
          "../../travelRequest/childApp/reportDepartment/report-by-department.vue"
        ),
      meta: {
        appName: "reportByDepartment",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "reportByEmployee",
      path: "/app/vehicle-usage/report-by-employee",
      component: () =>
        import(
          "../../travelRequest/childApp/reportEmployee/report-by-employee.vue"
        ),
      meta: {
        appName: "reportByEmployee",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "reportByVehicleUsage",
      path: "/app/vehicle-usage/report-by-vehicle-usage",
      component: () =>
        import(
          "../../travelRequest/childApp/reportVehicleUsage/report-by-vehicle-usage.vue"
        ),
      meta: {
        appName: "reportByVehicleUsage",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "reportVehicleUsageCard",
      path: "/app/vehicle-usage/report-vehicle-usage-card",
      component: () =>
        import(
          "../childApp/reportVehicleUsageCard/report-vehicle-usage-card.vue"
        ),
      meta: {
        appName: "reportVehicleUsageCard",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "addVehicleLog",
      path: "/app/vehicle-usage/vehicle-log/add",
      component: () =>
        import("@/views/mainApp/components/travelRequest/VehicleLogAdd.vue"),
      props: true,
      meta: {
        appName: "addVehicleLog",
      },
    },
    {
      name: "editVehicleLog",
      path: "/app/vehicle-usage/vehicle-log/:idVehicleLog/edit",
      component: () =>
        import("@/views/mainApp/components/travelRequest/VehicleLogEdit.vue"),
      props: true,
      meta: {
        appName: "editVehicleLog",
      },
    },
    {
      name: "listVehicleLog",
      path: "/app/vehicle-usage/vehicle-log",
      component: () =>
        import("@/views/mainApp/components/travelRequest/VehicleLogList.vue"),
      props: true,
      meta: {
        appName: "listVehicleLog",
      },
    },
  ],
};
